var _path, _path2, _path3, _path4, _path5, _path6, _path7, _ellipse, _circle, _ellipse2, _ellipse3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyStateNoSongs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.5343 36.406C46.8604 36.406 42.8315 40.724 41.028 44.6854C39.2246 48.6468 39.6253 50.6276 38.8238 54.1928C37.9948 57.8804 36.2863 63.1478 27.5656 64.125C17.2944 65.2759 14.693 54.1599 16.5192 49.066C18.651 43.1196 23.4958 43.3114 23.6896 37.1733C23.8834 31.0351 21.8586 27.9659 24.271 24.3214C27.9532 18.7587 35.3174 18.6591 42.8755 20.9609C50.4969 23.282 52.9417 24.2281 56.0924 25.181C66.2269 28.2461 68.2945 33.7205 66.5503 36.406C64.8061 39.0914 59.1544 36.406 53.5343 36.406Z",
    fill: "url(#paint0_linear_20544_73758)",
    fillOpacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4997 16.2141C46.9009 19.8102 49.3128 25.8241 36.3226 28.8208C33.9569 29.3666 32.1778 30.7613 26.7819 31.7602C21.322 32.7709 14.5473 32.5456 13.1147 39.1355C11.3317 47.3373 26.9725 53.2673 31.9779 54.9352C37.9735 56.933 41.3919 57.508 50.3639 58.7311C59.1574 59.9298 64.5132 57.6929 66.112 52.6982C67.5738 48.1315 65.9521 45.0224 64.8329 36.707C64.1533 31.658 63.5539 23.7688 61.3556 17.5754C59.1573 11.3821 51.1172 10.3265 48.4997 16.2141Z",
    fill: "url(#paint1_linear_20544_73758)",
    fillOpacity: 0.07
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.1589 42.9305C49.3342 42.9305 47.855 44.4213 47.855 46.2602C47.855 48.0992 49.3342 49.5899 51.1589 49.5899C52.9836 49.5899 54.4628 48.0992 54.4628 46.2602C54.4628 44.4213 52.9836 42.9305 51.1589 42.9305ZM45.6524 46.2602C45.6524 43.1953 48.1177 40.7108 51.1589 40.7108C54.2001 40.7108 56.6654 43.1953 56.6654 46.2602C56.6654 49.3251 54.2001 51.8097 51.1589 51.8097C48.1177 51.8097 45.6524 49.3251 45.6524 46.2602Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9302 49.2315C25.1055 49.2315 23.6263 50.7223 23.6263 52.5612C23.6263 54.4001 25.1055 55.8909 26.9302 55.8909C28.7549 55.8909 30.2341 54.4001 30.2341 52.5612C30.2341 50.7223 28.7549 49.2315 26.9302 49.2315ZM21.4237 52.5612C21.4237 49.4963 23.8891 47.0117 26.9302 47.0117C29.9714 47.0117 32.4368 49.4963 32.4368 52.5612C32.4368 55.6261 29.9714 58.1107 26.9302 58.1107C23.8891 58.1107 21.4237 55.6261 21.4237 52.5612Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.4628 24.907V46.2602H56.6654V24.4332C56.6654 23.2298 55.5432 22.3467 54.3847 22.6386L31.6245 29.0352C30.8074 29.241 30.2341 29.9809 30.2341 30.8298V52.5612H32.4368V31.1186L54.4628 24.907Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.8312 30.4817L31.6026 37.2482L31.0683 35.0947L55.297 28.3282L55.8312 30.4817Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.331 55.4664C58.308 56.4595 57.6644 58.8107 57.1149 61.6231C55.5241 69.7658 45.7804 64.8007 46.3771 59.4385C46.7938 55.6933 49.3863 54.2317 54.331 55.4664Z",
    fill: "url(#paint2_linear_20544_73758)",
    fillOpacity: 0.15
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.758,
    cy: 13.3219,
    rx: 2.98286,
    ry: 3.57944,
    transform: "rotate(20.4825 43.758 13.3219)",
    fill: "url(#paint3_linear_20544_73758)",
    fillOpacity: 0.15
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70.1318,
    cy: 48.1609,
    r: 1.43259,
    fill: "url(#paint4_linear_20544_73758)",
    fillOpacity: 0.15
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.56285,
    cy: 37.6562,
    rx: 2.12628,
    ry: 2.97679,
    transform: "rotate(20.6101 9.56285 37.6562)",
    fill: "url(#paint5_linear_20544_73758)",
    fillOpacity: 0.07
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.7221,
    cy: 36.3579,
    rx: 1.34524,
    ry: 1.88334,
    transform: "rotate(20.6101 4.7221 36.3579)",
    fill: "url(#paint6_linear_20544_73758)",
    fillOpacity: 0.07
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20544_73758",
    x1: 39.7217,
    y1: 61.8425,
    x2: 19.9107,
    y2: 18.3334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20544_73758",
    x1: 37.9202,
    y1: 56.5736,
    x2: 17.2508,
    y2: 10.9853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_20544_73758",
    x1: 51.5399,
    y1: 65.3483,
    x2: 46.37,
    y2: 55.1685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_20544_73758",
    x1: 43.5455,
    y1: 16.5222,
    x2: 39.7601,
    y2: 10.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_20544_73758",
    x1: 70.0297,
    y1: 49.4417,
    x2: 68.6485,
    y2: 46.7918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_20544_73758",
    x1: 9.41137,
    y1: 40.3177,
    x2: 6.07719,
    y2: 35.7485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_20544_73758",
    x1: 4.62626,
    y1: 38.0417,
    x2: 2.5168,
    y2: 35.1509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateNoSongs);
export default __webpack_public_path__ + "static/media/emptyStateNoSongs.765eb158.svg";
export { ForwardRef as ReactComponent };